export default [
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `I gather my courage, and go for the kiss.`,
        speakerTxtRS: `Skupim svoj hrabrost, i približim se za poljubac.`,
        dialogFx: `assets/dialog/joseph/joseph0102.mp3`,
        choicesBtns: `unset`
    }
]